type TTabContent = {
  active: boolean;
};
export const TabContent: React.FC<TTabContent> = ({ active, children }) => {
  return <div className="relative">{children}</div>;
};
